'use client';

import { ButtonStyled } from "@/components/UI/Button/Button.styled";
import Link from "next/link";
import { forwardRef, Fragment } from "react";
import Form from "@/components/UI/Form/Form/Form";
import {ButtonLoader} from "./Button.styled";

const Button = forwardRef(
    (
        {
            variant,
            color,
            size,
            api,
            endpoint,
            initialValues,
            children,
            type = "button",
            loading,
            ...props
        },
        ref
    ) => {
        const Component = props.href ? Link : null;

        const Wrapper =
            api && endpoint
                ? ({ children }) => (
                    <Form
                        api={api}
                        endpoint={endpoint}
                        initialValues={initialValues}
                    >
                        {children}
                    </Form>
                )
                : Fragment;

        return (
            <Wrapper>
                <ButtonStyled
                    {...props}
                    ref={ref}
                    type={api && endpoint ? "submit" : type}
                    variant={variant}
                    color={color}
                    size={size}
                    as={Component}
                    $loading={loading}
                    disabled={loading || props.disabled}
                >
                    {loading && <ButtonLoader size={'small'} />}
                    {children}
                </ButtonStyled>
            </Wrapper>
        );
    }
);

Button.displayName = "Button";

export default Button;
